import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Undo = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8289 9.43363C12.9914 5.71404 8.3922 4.36366 5.67669 7.04001L4.33972 8.35771L4.33973 6.44795C4.33973 6.17181 4.11587 5.94795 3.83973 5.94795C3.56359 5.94795 3.33973 6.17181 3.33973 6.44795L3.33972 9.55253C3.33972 9.68514 3.3924 9.81232 3.48616 9.90609C3.57993 9.99986 3.70711 10.0525 3.83972 10.0525L6.9443 10.0525C7.22045 10.0525 7.4443 9.82866 7.4443 9.55252C7.4443 9.27638 7.22044 9.05252 6.9443 9.05252L5.05933 9.05253L6.37865 7.75223C8.53537 5.62661 12.1881 6.69912 12.8533 9.65331C12.914 9.9227 13.1816 10.0919 13.451 10.0313C13.7204 9.9706 13.8896 9.70303 13.8289 9.43363Z"
        fill={color}
      />
    </svg>
  )
})

export default Undo
